module.exports = "<react-generic-message-modal cancel=negButton description=text is-open=true size=400 submit=posButton title=header /> ";